import { useCallback, useState } from 'react';
import { BottomSheet } from '@/ui/components';
import { Button } from '@/ui/components/Button';
import { Icon } from '@/ui/icons/Icon';
import { identityCheck } from '@/assets/images/offer';
import styles from './LastStepModal.module.scss';

const title = 'Ultimul pas';
const description = 'Confirmă-ți identitatea pentru a primi oferta finală';

interface UseLastStepModalOptions {
  trackingId: string;
  onConfirm: () => void;
}

// Before KYC: the preliminary offer turns final once the identity is confirmed.
export function useLastStepModal({ trackingId, onConfirm }: UseLastStepModalOptions) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return {
    open,
    close,
    modal: (
      <BottomSheet
        open={isOpen}
        onOpenChange={setIsOpen}
        ariaLabel={title}
        ariaDescription={description}
        enableDrag
        closeOnOverlay
      >
        <div className={styles.root}>
          <div className={styles.header}>
            <div className={styles.visual}>
              <img
                src={identityCheck}
                alt=""
                width={215}
                height={125}
                className={styles.image}
              />
            </div>
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.description}>{description}</p>
          </div>
          <Button
            trackingId={trackingId}
            variant="filled"
            size="medium"
            text="Confirmă identitatea"
            rightIcon={<Icon name="arrow-right" />}
            onClick={onConfirm}
            className={styles.button}
          />
          <p className={styles.duration}>
            <Icon name="clock" size={16} />
            Durează 2 minute
          </p>
        </div>
      </BottomSheet>
    ),
  };
}
